import { Box, Link } from '@mui/material';
import { EVENT_LOCATION, useTrackEvent } from '@src/hooks/useTrackEvent';
import { DateTime } from 'luxon';
import { EVENT_TITLE } from '@src/enums/event-title-enum';
import { Lozenge } from '@tractorzoom/components';
import Paper from '@src/components/paper/paper';
import PartnerLogo from '@src/components/partner-logo/partner-logo';
import React from 'react';
import { useGoTo } from '@src/hooks/use-go-to';
import useStyles from './styles';

type Props = {
    auction: {
        auctioneer: { company: string; logo: string; slug: string };
        biddingUrl: string;
        date: string;
        lotCount: number;
        name: string;
        type: string;
        url: string;
    };
    children?: React.ReactNode;
};

const AuctionSummary = ({ auction, children }: Props) => {
    const classes = useStyles();
    const { goToAuctioneer } = useGoTo();

    const trackEvent = useTrackEvent();
    const handleAuctioneerClick = () => {
        trackEvent(EVENT_TITLE.AuctioneerLink, { location: EVENT_LOCATION.AUCTION });
        goToAuctioneer({ auctioneerSlug: auction.auctioneer.slug });
    };

    return (
        <Paper>
            <Box display='flex' flexDirection='column'>
                <PartnerLogo image={auction.auctioneer?.logo} name={auction.name} />
                <span className={`${classes.auctionDate} ${classes.auctionDetailsContactInfoItem}`}>
                    {DateTime.fromMillis(Number(auction.date)).toFormat('EEE. MMM dd, yyyy')}
                </span>
                <Box display='flex' alignSelf='center' className={classes.lozenges}>
                    <Lozenge color='#39445A' backgroundColor='#E7E8EB'>
                        {auction.lotCount} LOTS
                    </Lozenge>
                    <Lozenge color='#39445A' backgroundColor='#E7E8EB'>
                        {auction.type?.toUpperCase()}
                    </Lozenge>
                </Box>
                <Link
                    href='#'
                    alignSelf='center'
                    onClick={handleAuctioneerClick}
                    className={`${classes.mediumBold} ${classes.alignRight} ${classes.auctioneerCompany}`}
                >
                    {auction.auctioneer?.company}
                </Link>
            </Box>
            {children}
        </Paper>
    );
};

export default AuctionSummary;
